import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import Button from '../../components/Button';
import AuthServices from '../../services/AuthServices';
import { NO_INTERNET } from 'components/messageError';

const ConfirmEmail = ({ onBack, isEmail }) => {
  const [loading, setLoading] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);

  const [countdown, setCountdown] = useState(60);
  const [intervalId, setIntervalId] = useState(null);

  const handleSubmit = () => {
    const bodyData = {
      email: isEmail,
    };
    setLoading(true);
    AuthServices.confirmEmail(bodyData)
      .then((res) => {
        if (res.isOk) {
          toast.success('メールの再送信に成功しました');
          setDisableSubmit(true);
          startCountdown();
        }
      })
      .catch((err) => toast.error(err.message || err || NO_INTERNET))
      .finally(() => setLoading(false));
  };

  const hideEmail = (email) => {
    const parts = email.split('@');
    const username = parts[0];
    const domain = parts[1];

    const hiddenUsername = `${username.substring(0, 2)}****${username.slice(
      -1
    )}`;

    const hiddenDomain = `${domain.charAt(0)}*****${domain.slice(-1)}`;
    return `${hiddenUsername}@${hiddenDomain}`;
  };
  const hiddenEmail = hideEmail(isEmail);

  const startCountdown = () => {
    const id = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown === 0) {
          clearInterval(id);
          setDisableSubmit(false);
          return 60;
        }
        return prevCountdown - 1;
      });
    }, 1000);
    setIntervalId(id);
  };

  useEffect(() => {
    return () => {
      clearInterval(intervalId);
    };
  }, [intervalId]);

  return (
    <>
      <div>
        <h2 className="text-welcome" style={{ paddingLeft: 0 }}>
          メールアドレスをご確認ください。
        </h2>
        <div>
          <div className="text-title">
            パスワードリセットの案内を <span>{hiddenEmail}</span>{' '}
            のメールアドレス宛にお送りしました。
          </div>
          <div className="text-title mt-[40px] 2xl:mt-[60px]">
            パスワードリセットの案内メールが届かない場合は、迷惑メールフォルダまたはプロモーションフォルダーをご確認ください
          </div>
        </div>
      </div>
      <div style={{ marginTop: '30px' }}>
        <Button
          style={{ marginTop: '0px !important', width: '100%' }}
          loading={loading}
          btnType="primary"
          fontWeight="bold"
          onClick={handleSubmit}
          disabled={disableSubmit}
        >
          メールを再送信する
          {disableSubmit && <div>({countdown})</div>}
        </Button>
        <Button
          btnType="auth-back"
          fontWeight="bold"
          style={{ marginTop: '30px' }}
          onClick={onBack}
        >
          ログイン画面に戻る
        </Button>
      </div>
    </>
  );
};

export default ConfirmEmail;
